const RESOURCES = [];

export {};

export default RESOURCES;
